import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/news", label: "影视资讯" },
  { to: "/search", label: "搜索影视" },
];

const categories = [
  { to: "/category?type=电视剧", label: "电视剧" },
  { to: "/category?type=电影", label: "电影" },
  { to: "/category?genre=爱情", label: "爱情" },
  { to: "/category?genre=喜剧", label: "喜剧" },
  { to: "/category?genre=悬疑", label: "悬疑" },
  { to: "/category?genre=科幻", label: "科幻" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
              <i className="ri-clapperboard-line text-xl"></i>
            </span>
            <span className="font-heading font-bold text-xl text-background-50">
              顽皮的女朋友
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
            顽皮的女朋友影视内容站是一个专注于影视作品资料展示与剧情资讯分享的聚合平台。
            我们围绕《顽皮的女朋友》及同类型影视作品，为用户提供剧集介绍、分类浏览、剧情解读与最新资讯。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-youtube-fill"].map((icon) => (
              <span
                key={icon}
                className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className={`${icon} text-base`}></i>
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-background-50 text-base tracking-wide">
            <a href="/" className="hover:text-accent-400 transition-colors">
              快捷导航
            </a>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-background-50 text-base tracking-wide">
            <a href="/category" className="hover:text-accent-400 transition-colors">
              热门分类
            </a>
          </h4>
          <ul className="mt-4 grid grid-cols-2 gap-2.5">
            {categories.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 顽皮的女朋友影视内容站 · 保留所有权利</p>
          <p className="text-center sm:text-right">
            本站内容均为演示资料，仅供学习交流，不涉及真实数据与商业用途。
          </p>
        </div>
      </div>
    </footer>
  );
}